import { ReactNode, createContext, useContext } from 'react';
import { NewWidget } from 'widgets/Widget.types';

interface UploadMenuContextType {
  addUploadImageWidget: (widget: NewWidget | NewWidget[]) => void;
}

interface UploadMenuProviderProps {
  children: ReactNode;
  addUploadImageWidget: (widget: NewWidget | NewWidget[]) => void;
}

export const UploadMenuContext = createContext<UploadMenuContextType>({
  addUploadImageWidget: () => {},
});

export const useUploadMenu = () => {
  const uploadMenuContext = useContext(UploadMenuContext);
  return uploadMenuContext;
};

export const UploadMenuContextProvider: React.FC<UploadMenuProviderProps> = ({ children, addUploadImageWidget }) => {
  return <UploadMenuContext.Provider value={{ addUploadImageWidget }}>{children}</UploadMenuContext.Provider>;
};
